@switch (sessionOccasion) {
  @case ('ReligionEventFirstCommunion') {
    <h1>Aby spersonalizować Twoje produkty, podaj imię swojego dziecka</h1>
  }
}

<ng-container [formGroup]="model">
  <mat-form-field libZalamoField>
    <mat-label>Imię</mat-label>
    <input type="text" formControlName="firstName" matInput />
    <lib-zalamo-field-decoration></lib-zalamo-field-decoration
  ></mat-form-field>
  <lib-button (click)="saved.next(model.value)" [disabled]="model.invalid"
    >Zapisz</lib-button
  >
</ng-container>
